import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=c80cac02&scoped=true"
import script from "./BasicInformation.vue?vue&type=script&lang=js"
export * from "./BasicInformation.vue?vue&type=script&lang=js"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=c80cac02&prod&scoped=true&lang=css"
import style1 from "./BasicInformation.vue?vue&type=style&index=1&id=c80cac02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80cac02",
  null
  
)

export default component.exports